@if (isEsko) {
  <span>Esko</span>
} @else {
  <span>Zeffi</span>
}
